<template>
    <div class="ehr-referral-pool-history">
        <common-loader :isProcessing="isSending"></common-loader>
        <common-page-plain v-if="ehrReferralsOnly.length && !isSending" :hasLargePadding="true">
            <common-content-spacer height="medium">
                <div class="ehr-referral-pool-history__table-wrap">
                    <referrals-pool-index-listing
                        :referrals="ehrReferralsOnly"
                        :isFromPatient="false"
                        type="made"
                        :filterOptions="[]"
                    ></referrals-pool-index-listing>
                </div>
                <common-buttons>
                    <common-button
                        v-if="referrals.length < referralsTotalCount"
                        :isProcessing="isProcessing"
                        :label="$t('pages.referrals.index.buttons.show_more')"
                        type="primary"
                        size="large"
                        @click="showMore"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-page-plain>
        <div v-if="!ehrReferralsOnly.length && !isSending" class="ehr-referral-pool-history__empty">
            {{ $t('pages.referrals.index.empty_state.no_referrals') }}
        </div>
    </div>
</template>

<script>
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'
    import ReferralsPoolIndexListing from 'components/page-elements/referrals/ReferralsPoolIndexListing'

    export default {
        name: 'ehr-referral-pool-history',

        components: {
            ReferralsPoolIndexListing,
        },

        provide() {
            return {
                isReferralPool: true,
            }
        },

        data() {
            return {
                referrals: [],
                offset: 0,
                referralsTotalCount: 0,
                isSending: false,
                isProcessing: false,
                listLimit: 10,
            }
        },

        computed: {
            ehrReferralsOnly() {
                const list = Array.isArray(this.referrals) ? this.referrals : []
                return list.filter((r) => r?.referralData?.externalBooking === 'ehr')
            },
        },

        methods: {
            getUserOrPracticeId() {
                if (this.$auth.isPracticeAncillary()) {
                    return this.$auth.getPractice().id
                }
                return this.$auth.getActiveMember()?.id ?? this.$auth.getUser().id
            },

            showMore() {
                this.offset = this.offset + this.listLimit
                this.fetchEhrReferralPoolHistory(true)
            },

            fetchEhrReferralPoolHistory(append) {
                if (!append) {
                    this.isSending = true
                } else {
                    this.isProcessing = true
                }
                ReferralsPoolAPI.getReferralsPool('made', this.getUserOrPracticeId(), {
                    state: 'all',
                    limit: this.listLimit,
                    offset: this.offset,
                    externalBooking: 'ehr',
                    feasibility: true,
                })
                    .then((response) => {
                        if (append) {
                            this.referrals = this.referrals.concat(response)
                            return
                        }
                        this.referralsTotalCount = response._headers['x-total-count']
                        this.referrals = response
                    })
                    .finally(() => {
                        this.isSending = false
                        this.isProcessing = false
                    })
            },
        },

        watch: {
            referrals() {
                if (this.referrals._headers) {
                    this.referralsTotalCount = this.referrals._headers['x-total-count']
                }
            },
        },

        mounted() {
            this.referrals = []
            this.offset = 0
            this.fetchEhrReferralPoolHistory()
        },
    }
</script>

<style lang="scss">
    .ehr-referral-pool-history {
        padding: 1.5rem;
    }
    .ehr-referral-pool-history__empty {
        padding: 1.5rem 0;
        text-align: center;
    }

    .ehr-referral-pool-history__table-wrap {
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    /* Desktop only: listing hides some columns when isTablet (<=1024px); fixed widths match 5-column layout. */
    @media (min-width: 1025px) {
        .ehr-referral-pool-history__table-wrap ::v-deep .tracking-listing {
            table-layout: fixed;
            width: 100%;
            border-collapse: collapse;

            th,
            td {
                vertical-align: top;
                box-sizing: border-box;
            }

            th:nth-child(1),
            td:nth-child(1) {
                width: 14%;
            }

            th:nth-child(2),
            td:nth-child(2) {
                width: 18%;
            }

            th:nth-child(3),
            td:nth-child(3) {
                width: 30%;
            }

            th:nth-child(4),
            td:nth-child(4) {
                width: 14%;
            }

            th:nth-child(5),
            td:nth-child(5) {
                width: 24%;
                text-align: right;
            }

            .listing-listing__action {
                width: auto;
            }

            .tracking-listing__patient {
                width: 100%;
                max-width: 100%;
                min-width: 0;
            }
        }
    }
</style>
